import { render, staticRenderFns } from "./MailgunCopyButton.vue?vue&type=template&id=15375c48&scoped=true&"
import script from "./MailgunCopyButton.vue?vue&type=script&lang=js&"
export * from "./MailgunCopyButton.vue?vue&type=script&lang=js&"
import style0 from "./MailgunCopyButton.vue?vue&type=style&index=0&id=15375c48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15375c48",
  null
  
)

export default component.exports